import { Component } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TimelineSection } from "../../../_models/timeline-models/section-listing.model";
import { LearningSectionFlowControlHelperService } from "../../../_helpers/learning-section-flow-control-helper/learning-section-flow-control-helper.service";
import { TimelineSectionStudentInfo } from "../../../_models/timeline-models/timeline-section-student-info.model";
import { TimelineSectionStatus } from "../../../_models/timeline-models/timeline-section-status.enum";
import { Subject } from "rxjs";

@Component({
    selector: 'base-learning-section',
    templateUrl: 'base-learning-section.component.html',
    styleUrls: ['./base-learning-section.component.css'],
    standalone: false
})
export class BaseLearningSectionComponent {

  public sectionTitle: string = '';
  public editMode: boolean;
  public placementId: number;
  public studentId: number;
  public timelineSection: TimelineSection;
  public students: TimelineSectionStudentInfo[] = [];
  public subject: string;
  public minSectionDate: Date;
  public _sectionStatusUpdated: Subject<TimelineSectionStatus> = new Subject<TimelineSectionStatus>();
  /** Fired by a section (e.g. milestone delete) that mutates data outside the edit-modal flow and needs the timeline reloaded. */
  public reloadRequested: Subject<void> = new Subject<void>();

  public save?(dialogRef?: MatDialogRef<any>): void;
  public delete?(dialogRef?: MatDialogRef<any>): void;
  public submit?(dialogRef?: MatDialogRef<any>): void;
  public approve?(dialogRef?: MatDialogRef<any>): void;
  public reject?(dialogRef?: MatDialogRef<any>): void;
  public unlock?(dialogRef?: MatDialogRef<any>): void;
  public validate?(dialogRef?: MatDialogRef<any>): boolean;

  constructor(protected readonly flowHelperService: LearningSectionFlowControlHelperService,
    public dialog: MatDialog) { }

  public isFormEditable(): boolean {
    return this.flowHelperService.CanEditTimelineSection(this.timelineSection);
  }

  openSection(component: any): any {
    const dialogRef = this.dialog.open(component, {
      data: {
        editMode: true,
        timelineSection: { ...this.timelineSection },
        placementId: this.placementId,
        students: this.students,
        subject: this.subject
      },
      panelClass: 'my-timeline-edit-dialog'
    });
    return dialogRef;
  }

  public hasMethodInstantiated(method: string): boolean {
    return typeof this[method] === "function";
  }
}
